import { render, staticRenderFns } from "./SingleSolidPie.vue?vue&type=template&id=1c5ecbcc&scoped=true&lang=pug"
import script from "./SingleSolidPie.vue?vue&type=script&lang=js"
export * from "./SingleSolidPie.vue?vue&type=script&lang=js"
import style0 from "./SingleSolidPie.vue?vue&type=style&index=0&id=1c5ecbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ecbcc",
  null
  
)

export default component.exports